export const makeOrderOptions = () => {
	return [
		{
			value: 'id',
			label: 'ID'
		},
		{
			value: 'label',
			label: 'Label'
		},
		{
			value: 'type',
			label: 'Tipo'
		}
	]
}

export const makeFilterOptions = () => {
	return [
		{
			value: 'system',
			label: 'Sistêmica'
		},
		{
			value: 'user',
			label: 'Usuário'
		}
	]
}
